let config = {
    apiBaseUrl: API_BASE_URL || window.location.protocol + '//api-' + window.location.host,
    uploadsApiBaseUrl: API_BASE_URL || window.location.protocol + '//apinp-' + window.location.host,
}

const getConfig = function () {
    return config
}

export const updateConfig = newConfig => {
    config = { ...config, ...newConfig }
}

export default getConfig
